let BASE_URL
let COMMONS_SERVICE_BASE_URL
let CUSTOM_ENROLL_ID

if (process.env.REACT_APP_ENV === "development") {
  BASE_URL = "https://stgapi.omnicuris.com/"
  COMMONS_SERVICE_BASE_URL = "https://stg-commons-api.omnicuris.com/api/"
  CUSTOM_ENROLL_ID = [2]
}
if (process.env.REACT_APP_ENV === "preProduction") {
  BASE_URL = "https://preprodapi.omnicuris.com/"
  COMMONS_SERVICE_BASE_URL = "https://preprod-commons-api.omnicuris.com/api/"
  CUSTOM_ENROLL_ID = [2]
}
if (process.env.REACT_APP_ENV === "production") {
  BASE_URL = "https://api.omnicuris.com/"
  COMMONS_SERVICE_BASE_URL = "https://commons-api.omnicuris.com/api/"
  CUSTOM_ENROLL_ID = [2]
}

export { BASE_URL, COMMONS_SERVICE_BASE_URL, CUSTOM_ENROLL_ID }

export const APP_VERSION = "1.0.0"
